import { useNavigate } from "react-router-dom";
import "./StoryBanner.css";

function StoryBanner() {
  const navigate = useNavigate();

  return (
    <div
      className="story-banner"
      onClick={() => {
        navigate("/story");
        window.scrollTo(0, 0);
      }}
    >
      <h2 className="story-banner-title">The Story Behind Bitcoin Ilm</h2>
    </div>
  );
}

export default StoryBanner;
